import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../../Components/ModelContainer";
import Select from "../../../../Components/Select";
import Input from "../../../../Components/Input";
import ListDateInput from "../../../../Components/ListDateInput";
import ErrorContainer from "../../../../Components/ErrorContainer";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import DatePicker from "react-date-picker";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../Redux";
import DateInput from "../../../../Components/DateInput";
import { getFormData } from "../../../../../helpers";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LocalHeader from "./LocalHeader";

const QrOrdering = (params) => {
  const dispatch = useDispatch();

  const qrOrderData = useSelector(
    (state) => state?.settingReducer?.qrOrderData
  );

  const [pdfMenuModalType, setPdfMenuModalType] = useState("add");
  const [sectionHide, setSectionHide] = useState();
  const showPdfMenuModal = useSelector(
    (state) => state?.settingReducer.pdfMenuModal
  );
  const setShowPdfMenuModal = (formState) =>
    dispatch(actions?.setFormState({ formName: "pdfMenuModal", formState }));

  useEffect(() => {
    dispatch(actions?.getQrOrderData());
  }, []);

  useEffect(() => {
    setSectionHide({
      pdfMenu:
        qrOrderData?.qr_ordering?.pdf_menu_upload_enabled === "yes"
          ? true
          : false,
      selfServiceOrdering:
        qrOrderData?.qr_ordering?.self_service_ordering_enabled === "yes"
          ? true
          : false,
    });
    qrOrderReset(qrOrderDefaultState);
  }, [qrOrderData]);
  const qrOrderDefaultState = {
    pdf_menu_upload_enabled:
      qrOrderData?.qr_ordering?.pdf_menu_upload_enabled ?? "",
    self_service_ordering_enabled:
      qrOrderData?.qr_ordering?.self_service_ordering_enabled ?? "",
    categorisation_preference:
      qrOrderData?.qr_ordering?.categorisation_preference ?? "",
    qr_code_ids: qrOrderData?.qr_ordering?.pdf_menu_upload_enabled ?? "",
    qr_code_generation_frequency:
      qrOrderData?.qr_ordering?.qr_code_generation_frequency ?? "",
    auto_generate_qr_new_table:
      qrOrderData?.qr_ordering?.auto_generate_qr_new_table ?? "",
    auto_fire_upon_customer_submit:
      qrOrderData?.qr_ordering?.auto_fire_upon_customer_submit ?? "",
    pos_master_id: qrOrderData?.qr_ordering?.pos_master_id ?? "",
    order_received_message:
      qrOrderData?.qr_ordering?.order_received_message ?? "",
    hide_note: qrOrderData?.qr_ordering?.pdf_menu_upload_enabled ?? "",
  };
  const qrOrderSchema = yup.object({
    pdf_menu_upload_enabled: yup.string().required(),
    self_service_ordering_enabled: yup.string().required(),
    categorisation_preference: yup.string().required(),
    qr_code_ids: yup.string(),
    qr_code_generation_frequency: yup.string(),
    auto_generate_qr_new_table: yup.string(),
    auto_fire_upon_customer_submit: yup.string(),
    pos_master_id: yup.string(),
    order_received_message: yup.string(),
    hide_note: yup.string(),
  });
  const {
    register: qrOrderRegister,
    formState: { errors: qrOrderError },
    handleSubmit: qrOrderSubmit,
    reset: qrOrderReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(qrOrderSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: qrOrderDefaultState,
  });

  function submitData(data) {
    console.log(data);
    dispatch(actions?.postQrOrderData(data));
  }
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 mt-3">
          <div className="container px-0">
            <LocalHeader />

            <div class="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <div className="row lbrSettingMs d-flex">
                  <div className="col-md-12 modify">
                    <div className="shadowclass mt-md-4 mt-3 d-flex flex-wrap align-content-start">
                      <h4 className="event-alert w-100 mb-4">
                        Ordrr QR Settings
                      </h4>
                      <div className="d-flex calc-height w-100 flex-wrap">
                        <div className="settings-left-content fixed-pos col-3">
                          <ul className="settingMenus">
                            <li id="AccDetail_li" className="active">
                              <a href="#_" id="AccDetail_dayTime_a">
                                GENERAL
                              </a>
                            </li>
                            {sectionHide?.pdfMenu && (
                              <li id="Address_li" className="">
                                <a href="#_" id="Address_dayTime_a">
                                  PDF MENUS
                                </a>
                              </li>
                            )}

                            {sectionHide?.selfServiceOrdering && (
                              <li id="FinSettings_li" className="">
                                <a href="#_" id="FinSettings_dayTime_a">
                                  SELF-SERVICE ORDERING
                                </a>
                              </li>
                            )}
                          </ul>
                        </div>

                        <div className="settings-right-content scrolling col-9">
                          <form onSubmit={qrOrderSubmit(submitData)}>
                            <div className="date-sec-scroll">
                              <div
                                id="AccDetail_dayTime_div"
                                className="row-fluid scroll-change full_div"
                                day_time="AccDetail"
                              >
                                <div className="form-secs">
                                  <h4> General </h4>
                                  <ul class="ingredient-info edit-shift">
                                    <Select
                                      label={"PDF Menu Uploads Enabled?"}
                                      formRegister={qrOrderRegister}
                                      formError={qrOrderError}
                                      formKey={"pdf_menu_upload_enabled"}
                                      optionsArray={qrOrderData?.yes_no}
                                      onChange={(e) => {
                                        setSectionHide({
                                          ...sectionHide,
                                          pdfMenu:
                                            e.target.value === "yes"
                                              ? true
                                              : false,
                                        });
                                      }}
                                    />
                                    <Select
                                      label={
                                        "QR Self-Service Ordering Enabled?"
                                      }
                                      formRegister={qrOrderRegister}
                                      formError={qrOrderError}
                                      formKey={"self_service_ordering_enabled"}
                                      optionsArray={qrOrderData?.yes_no}
                                      onChange={(e) => {
                                        setSectionHide({
                                          ...sectionHide,
                                          selfServiceOrdering:
                                            e.target.value === "yes"
                                              ? true
                                              : false,
                                        });
                                      }}
                                    />
                                    <Select
                                      label={"Categorisation Preference"}
                                      formRegister={qrOrderRegister}
                                      formError={qrOrderError}
                                      formKey={"categorisation_preference"}
                                      optionsArray={[
                                        { value: "1", label: "Sub Category" },
                                        { value: "2", label: "Sub Class" },
                                      ]}
                                      onChange={(e) => {}}
                                    />
                                  </ul>
                                </div>
                              </div>
                              {sectionHide?.pdfMenu && (
                                <div
                                  id="Address_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="Address"
                                >
                                  <div className="form-secs">
                                    <h4> PDF Menu </h4>
                                    <ul class="table-list-ms w-100">
                                      <li>
                                        <div class="row justify-content-between align-items-center mx-0">
                                          <div class="col-md-4 col-12 px-0">
                                            <div class="search-box mt-0 w-100">
                                              <input
                                                type="text"
                                                className="col-12"
                                                placeholder="Search"
                                                name="keyword1"
                                                value=""
                                              />
                                              <input type="button" />
                                            </div>
                                          </div>
                                          <div class="col-md-6 col-12 align-right px-0">
                                            <div class="field text-right">
                                              <button
                                                onClick={() => {
                                                  dispatch(
                                                    actions?.downloadQrList()
                                                  );
                                                }}
                                                class="btn bordered-btn mx-0 mt-md-0 mt-3"
                                              >
                                                Download All QRs
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                      <li>
                                        <div className="table-responsive">
                                          <table className="checklist-table pdf_menu_tables remove-space filterTable sortTable">
                                            <thead>
                                              <tr>
                                                <th class="header">
                                                  Menu Name &amp; Status
                                                </th>
                                                <th class="header">
                                                  {" "}
                                                  QR Code ID{" "}
                                                </th>
                                                <th class="header">
                                                  {" "}
                                                  Start Date{" "}
                                                </th>
                                                <th class="header">
                                                  {" "}
                                                  End Date{" "}
                                                </th>
                                                <th class="header">
                                                  {" "}
                                                  File Name{" "}
                                                </th>
                                                <th class="header">
                                                  {" "}
                                                  Actions{" "}
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody class="">
                                              {qrOrderData?.qr_ordering?.qr_pdf_menu?.map(
                                                (el) => {
                                                  return (
                                                    <tr>
                                                      <td>
                                                        <strong>
                                                          {el?.menu_name}
                                                        </strong>
                                                        <div>
                                                          {el?.status == "1"
                                                            ? "Active"
                                                            : "Inactive"}
                                                        </div>
                                                      </td>
                                                      <td>{el?.qr_code_id}</td>
                                                      <td>{el?.start_date}</td>
                                                      <td>{el?.end_date}</td>
                                                      <td>
                                                        {el?.file_name?.slice(
                                                          5,
                                                          10
                                                        )}
                                                      </td>
                                                      <td>
                                                        <p
                                                          onClick={() => {
                                                            setPdfMenuModalType(
                                                              "edit"
                                                            );
                                                            setShowPdfMenuModal(
                                                              true
                                                            );
                                                            const editData =
                                                              qrOrderData?.qr_ordering?.qr_pdf_menu?.find(
                                                                (item) =>
                                                                  item.id ===
                                                                  el?.id
                                                              );
                                                            dispatch(
                                                              actions?.editSavePdfMenuData(
                                                                editData
                                                              )
                                                            );
                                                          }}
                                                          className="circle_icon edit_tooltip"
                                                        >
                                                          <i class="iconSprites edit-icon"></i>{" "}
                                                        </p>
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                        <div
                                          onClick={() => {
                                            setShowPdfMenuModal(true);
                                            setPdfMenuModalType("Add");
                                          }}
                                          class="my-3"
                                        >
                                          <button
                                            class="btn green-btn-revert add-plus"
                                            id="addPdfMenu"
                                            type="button"
                                          >
                                            <i class="i-icon"> </i> Add Menu
                                          </button>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                              {sectionHide?.selfServiceOrdering && (
                                <div
                                  id="FinSettings_dayTime_div"
                                  className="row-fluid scroll-change full_div"
                                  day_time="FinSettings"
                                >
                                  <div className="form-secs">
                                    <h4> Self-Service Ordering </h4>
                                    <ul class="ingredient-info edit-shift d-flex">
                                      <Select
                                        label={"QR Code Generation Frequency"}
                                        formRegister={qrOrderRegister}
                                        formError={qrOrderError}
                                        formKey={"qr_code_generation_frequency"}
                                        optionsArray={
                                          qrOrderData?.qrGenerationFrequency
                                        }
                                        onChange={(e) => {}}
                                        notRequired
                                      />

                                      <Select
                                        label={
                                          "Auto Generate QR for New Tables?"
                                        }
                                        formRegister={qrOrderRegister}
                                        formError={qrOrderError}
                                        formKey={"auto_generate_qr_new_table"}
                                        optionsArray={qrOrderData?.yes_no}
                                        onChange={(e) => {}}
                                        notRequired
                                      />

                                      <Select
                                        label={
                                          "Auto Fire Upon Customer Submit? "
                                        }
                                        formRegister={qrOrderRegister}
                                        formError={qrOrderError}
                                        formKey={
                                          "auto_fire_upon_customer_submit"
                                        }
                                        optionsArray={qrOrderData?.yes_no}
                                        onChange={(e) => {}}
                                        notRequired
                                      />

                                      <li className="h-auto">
                                        <div class="select-days">
                                          <label>
                                            {" "}
                                            Order Received Message{" "}
                                          </label>
                                          <div class="input-group">
                                            <textarea
                                              {...qrOrderRegister(
                                                "order_received_message"
                                              )}
                                              id=""
                                              cols="30"
                                              rows="10"
                                            ></textarea>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div class="paddingtb10">
                              <div class="btns d-flex justify-content-end">
                                <button
                                  class="btn"
                                  name="submit"
                                  type="submit"
                                  id="cancel"
                                >
                                  Cancel
                                </button>
                                <button class="btn" name="submit" type="submit">
                                  Save
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="menu-sequencing"
                role="tabpanel"
                aria-labelledby="menu-sequencing-tab"
              >
                <div className="shadowclass mt-md-4 mt-3 integrationEditMs">
                  <h4 class="event-alert"> Ordrr QR Menu &amp; Sequencing </h4>
                  <div className="row mx-0">
                    <div className="table-responsive min-width-table">
                      <table
                        id="menu_sequencing"
                        class="checklist-table remove-space"
                      >
                        <thead>
                          <tr>
                            <th className="col-1 text-right"> Sequence ID </th>
                            <th className="col-2"> Sequence Type </th>
                            <th className="col-3"> Menu Name </th>
                            <th className="col-5"> </th>
                          </tr>
                        </thead>
                        <tbody id="menu_sequencing_body">
                          <tr>
                            <td colspan="4" className="p-0">
                              <table class="table category-table">
                                <tr class="categ-tr activerow">
                                  <td class="col-1 align-right">1-00000</td>
                                  <td className="col-2"> Sub-Category</td>
                                  <td className="col-3">
                                    {" "}
                                    1-For-1 Lunch Deals
                                  </td>
                                  <td className="col-5 btns-table-sec">
                                    <button
                                      type="button"
                                      class="btn_btnblue categoryup"
                                    >
                                      Move Up Section
                                    </button>
                                    <button
                                      type="button"
                                      class="btn_btnblue categorydown"
                                    >
                                      Move Down Section
                                    </button>
                                    <button
                                      type="button"
                                      class="btn_btnblue categorystatus activate"
                                    >
                                      Deactivate
                                    </button>
                                  </td>
                                </tr>

                                <tr class="menutr category-0 activerow">
                                  <td class="menu col-1"> 1-00001 </td>
                                  <td className="col-2">MenuItems</td>
                                  <td className="col-3">
                                    Beef Rendang with Basmati Rice (1-for-1)
                                  </td>
                                  <td className="col-5 btns-table-sec">
                                    <button
                                      type="button"
                                      class="btn_btnblue menuup"
                                    >
                                      Move Up Item
                                    </button>
                                    <button
                                      type="button"
                                      class="btn_btnblue menudown"
                                    >
                                      Move Down Item
                                    </button>
                                    <button
                                      type="button"
                                      class="btn_btnblue menustatus category-0-button activate"
                                    >
                                      Deactivate
                                    </button>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="qr-list"
                role="tabpanel"
                aria-labelledby="qr-list-tab"
              >
                <div class="row mx-0">
                  <div class="shadowclass mt-md-4 mt-3">
                    <div class="col-12">
                      <div class="counts">
                        <h4 class="event-alert"> Table QR List </h4>
                        <div className="row justify-content-between align-items-center w-100 mx-0">
                          <div class="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                            <div class="search-box mt-0">
                              <form
                                action="/productions"
                                id="MenuItemIndexForm"
                                method="get"
                                accept-charset="utf-8"
                              >
                                <input
                                  name="keyword"
                                  placeholder="Search"
                                  type="text"
                                  id="MenuItemKeyword"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div class="col-sm-7 col-12 px-0 d-flex align-items-center justify-content-md-end justify-content-between">
                            <button
                              class="btn bordered-btn mx-0 px-1"
                              type="button"
                              id="reGenerateQrs"
                            >
                              {" "}
                              Re-Generate Selected QRs{" "}
                            </button>
                            <button
                              class="btn bordered-btn mx-0 px-1"
                              type="button"
                              id="downloadQrs"
                            >
                              {" "}
                              Download Selected QRs{" "}
                            </button>
                          </div>
                        </div>

                        <div className="shadowclass mt-0 px-0">
                          <div className="table-responsive">
                            <table className="checklist-table remove-space inventory_table">
                              <thead>
                                <tr>
                                  <th width="40">
                                    <a class="checkbox avaiCheck">
                                      <input
                                        type="checkbox"
                                        name="master_check"
                                        class="avail_checkbox"
                                        value=""
                                        id="checkbox_menu_id"
                                      />
                                      <label for="checkbox_menu_id"></label>
                                    </a>
                                  </th>
                                  <th> Table &amp; Room </th>
                                  <th> QR Code ID </th>
                                  <th> Start Date </th>
                                  <th> End Date </th>
                                  <th class="action-td"> Actions </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <a class="checkbox avaiCheck">
                                      <input
                                        type="checkbox"
                                        name="ids[]"
                                        class="avail_checkbox child_box"
                                        value="15558"
                                        id="order_id_15558"
                                      />
                                      <label for="order_id_15558"> </label>
                                    </a>
                                  </td>
                                  <td>
                                    {" "}
                                    <strong> Table - ru </strong>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <a
                                        href="#_"
                                        class="circle_icon refreshTableQrcode"
                                        val="356"
                                      >
                                        <i class="iconSprites refresh-icon"></i>
                                      </a>
                                      <div className="green-txt mx-2">
                                        9824238782
                                      </div>
                                    </div>
                                  </td>

                                  <td> 2022-01-24 </td>

                                  <td> </td>

                                  <td className="action-td">
                                    <a class="circle_icon" href="#_" val="356">
                                      <i class="iconSprites edit-icon">
                                        <div class="tooltip-sm">Edit</div>
                                      </i>
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <a class="checkbox avaiCheck">
                                      <input
                                        type="checkbox"
                                        name="ids[]"
                                        class="avail_checkbox child_box"
                                        value="15558"
                                        id="order_id_15558"
                                      />
                                      <label for="order_id_15558"> </label>
                                    </a>
                                  </td>
                                  <td>
                                    <strong> Table - Q </strong>
                                    AAA{" "}
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center">
                                      <a
                                        href="#_"
                                        class="circle_icon refreshTableQrcode"
                                        val="356"
                                      >
                                        <i class="iconSprites refresh-icon"></i>
                                      </a>
                                      <div className="green-txt mx-2">
                                        9824238782
                                      </div>
                                    </div>
                                  </td>

                                  <td> 2022-01-24 </td>

                                  <td> 2022-06-24 </td>

                                  <td className="action-td">
                                    <a class="circle_icon" href="#_" val="356">
                                      <i class="iconSprites edit-icon">
                                        <div class="tooltip-sm">Edit</div>
                                      </i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="history"
                role="tabpanel"
                aria-labelledby="history-tab"
              >
                <div class="row mx-0">
                  <div class="shadowclass mt-md-4 mt-3">
                    <div class="col-12">
                      <div class="counts">
                        <h4 class="event-alert"> History </h4>
                        <div class="row justify-content-between align-items-center mx-0">
                          <div class="col-md-6 col-12 px-0">
                            <div class="search-box mt-0 w-100">
                              <form
                                action="/productions"
                                id="MenuItemIndexForm"
                                method="get"
                                accept-charset="utf-8"
                              >
                                <input
                                  name="keyword"
                                  placeholder="Search"
                                  type="text"
                                  id="MenuItemKeyword"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                        </div>

                        <div className="shadowclass mt-0 px-0">
                          <div className="table-responsive">
                            <table className="checklist-table remove-space inventory_table">
                              <thead>
                                <tr>
                                  <th> Start </th>
                                  <th class="header"> End </th>
                                  <th class="header"> Field </th>
                                  <th class="header"> Value </th>
                                  <th class="header"> Replacement Value </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr></tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PDFMenuModal
          showPdfMenuModal={showPdfMenuModal}
          setShowPdfMenuModal={setShowPdfMenuModal}
          modalType={pdfMenuModalType}
        />
      </div>
    </UserInterface>
  );
};

const PDFMenuModal = ({ showPdfMenuModal, setShowPdfMenuModal, modalType }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const dispatch = useDispatch();

  const qrOrderData = useSelector(
    (state) => state?.settingReducer?.qrOrderData
  );
  const editData = useSelector(
    (state) => state?.settingReducer?.editPdfMenuData
  );
  const addDefaultState = {
    menu_name: "",
    start_date: "",
    end_date: "",
    file_name: "",
    status: "",
  };

  const editDefaultState = {
    menu_name: editData?.menu_name,
    start_date: editData?.start_date,
    end_date: editData?.end_date,
    file_name: editData?.file_name,
    status: editData?.status,
  };
  useEffect(() => {
    if (modalType !== "edit") return;
    setStartDate(editData?.start_date);
    setEndDate(editData?.end_date);
    reset(editDefaultState);
  }, [modalType, editData]);

  const schema = yup.object().shape({
    menu_name: yup.string().required(),
    start_date: yup.string().required(),
    end_date: yup.string().required(),
    file_name: yup
      .mixed()
      .required()
      .test("type", "Only PDF is supported", (value) => {
        console.log(value[0]?.type, value, "oooooo");
        return value?.[0]?.type === "application/pdf";
      }),
    status: yup.string().required(),
  });
  const submitData = (data) => {
    const submitData = getFormData({
      ...data,
      file_name: data.file_name[0],
    });
    if (modalType == "add") dispatch(actions?.postPdfMenu(submitData));
    else
      dispatch(
        actions?.editPostPdfMenuData({
          submitData: submitData,
          id: editData?.id,
        })
      );
  };
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: addDefaultState,
  });
  return (
    <ModelContainer
      title="Add Menu"
      open={showPdfMenuModal}
      closeModal={() => setShowPdfMenuModal(!showPdfMenuModal)}
      submitModal={handleSubmit(submitData)}
    >
      <form>
        <div className="form-list">
          <ul className="px-0">
            {/*edit account 1 */}
            {console.log(errors, "errors")}

            <Input
              label={"Menu Name"}
              formRegister={register}
              formError={errors}
              formKey="menu_name"
              isModal
            />
            <DateInput
              label={"Start Date"}
              formRegister={register}
              formError={errors}
              formKey="start_date"
              isModal
              dateVal={startDate}
              setDateVal={setStartDate}
              setFormField={setValue}
            />

            <DateInput
              label={"End Date"}
              formRegister={register}
              formError={errors}
              formKey="end_date"
              isModal
              dateVal={endDate}
              setDateVal={setEndDate}
              setFormField={setValue}
            />
            <Input
              label={"Upload PDF"}
              formRegister={register}
              formError={errors}
              formKey="file_name"
              isModal
              type="file"
            />
            {/* <li>
              <label> Upload</label>
              <input
                type="file"
                {...register("upload_url")}
                className="input-wrap select-div"
              />
            </li> */}
            <Select
              label={"Status"}
              formRegister={register}
              formError={errors}
              formKey="status"
              optionsArray={qrOrderData?.status}
              isModal
            />
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};

export default QrOrdering;
